const isDefined = (value = '') => value || parseInt(value, 10) === 0;
const applyIfDefined = fn => value => (isDefined(value) ? fn(value) : '');

export const issn = applyIfDefined(value => `https://www.google.com/search?q=issn: "${value}"`);
export const isbn = applyIfDefined(value => `https://www.google.com/search?q=isbn: "${value}"`);
export const doi = applyIfDefined(value => `http://dx.doi.org/${value}`);
export const pubmed = applyIfDefined(value => `https://www.ncbi.nlm.nih.gov/pubmed/${value}`);
export const arxiv = applyIfDefined(value => `https://arxiv.org/abs/${value}`);



// WEBPACK FOOTER //
// ./src/universal/ui/utils/identifier-url.js